import { Component, OnInit, OnDestroy } from '@angular/core';
import { WallboardService } from '../../../services/wallboard/wallboard.service';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';
import { ConfigService } from '../../../services/config/config.service';
import { MessageService } from 'src/app/services/message/message.service';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'app-wallboard-config-life',
  templateUrl: './wallboard-config-life.component.html',
  styleUrls: ['./wallboard-config-life.component.css']
})
export class WallboardConfigLifeComponent implements OnInit {

  public destroyed = new Subject<any>();
  newState: boolean;
  formValid: boolean;

  constructor(
    public messageService: MessageService,
    public wallboardService: WallboardService,
    private router: Router,
    public configService: ConfigService
  ) { }

  //set default values and subscribe refresh function to navigation event
  ngOnInit() {
    this.initData();
    this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.initData();
    });
  }

  //kill the subscription
  ngOnDestroy(){
    this.destroyed.next();
    this.destroyed.complete();
  }


  initData(){
    this.wallboardService.getConfigDataLife(this.configService.activeLOBLife);
    this.wallboardService.activeQueueNameLife = '';
    this.wallboardService.activeSiteNameLife = '';
    this.wallboardService.showWallboardLife = false;
    this.newState = true;
    this.formValid = true;
  }


  handleSiteChange(site){
    this.newState = false;
    if(site.length > 0){
      this.wallboardService.setActiveSiteLife(site);
    }else{
      this.initData();
    }
    
  }


  refreshConfig(){
    this.wallboardService.getConfigDataLife(this.configService.activeLOBLife).then((resp) => {
      this.wallboardService.setActiveSiteLife(this.wallboardService.activeSiteNameLife);
    });
  }


  updateConfig() {
    if(this.formValid){
      this.messageService.setNotification('saving ' + this.wallboardService.activeQueueConfigLife.View + '...', 'information', false);
      this.wallboardService.updateConfigLife(this.configService.activeLOBLife).then((resp) => {
        //console.log(resp);
        if(resp['status'] == 200){
          this.messageService.setNotification('changes were saved successfully', 'success', true);
          this.refreshConfig();
        }else{
          this.messageService.setNotification('changes were unsuccessful. If issue persists please contact IT support', 'error', true);
        }
      });
    }else{
      this.messageService.setNotification('There are problems with the current configuration values. Please review your selections and re-submit.', 'error', true);
    }
  }


  validateInput(){
    if('AggregateView' in this.wallboardService.activeQueueConfigLife && this.wallboardService.activeQueueConfigLife['AggregateView'] == true){
      this.formValid = true;
      var combinedTitle = '';
      combinedTitle = this.wallboardService.activeQueueConfigLife['CombinedPane']['Title'];
      if(combinedTitle.trim() == ''){
        this.formValid = false;
      }
      var combinedQueue = [];
      combinedQueue = this.wallboardService.activeQueueConfigLife['CombinedPane']['QueueList'];
      if(combinedQueue.length == 0){
        this.formValid = false;
      }
    
    }else{
      this.formValid = true;
    }
    //console.log("form valid: " + String(this.formValid));
  }

  cancelSite(configactiveLOBLife){
    this.router.navigate(['/'+ configactiveLOBLife], {queryParams: {status: 'true'} } );
  }

}
